export const replicationUrnPlatform = 'urn:platform:';
